<template>
    <div class="row">
        <div class="col-12" v-if="title">
            <TitleComponent :title="'ZONA SELECCIONADA: ' + zona.name"></TitleComponent>
        </div>
        <div class="col-12">
            <h1>{{ zona.sector }}</h1>
        </div>
        <div class="col-12">
            <p>Haz click en el siguiente selector para cambiar de zona</p>
            <div class="form-group" v-if="zonas">
                <multiselect
                    v-model="new_zona"
                    placeholder="Seleccionar zona"
                    label="name"
                    track-by="code"
                    :options="select_zonas"
                ></multiselect>
            </div>
        </div>
        <div class="col-12">
            <div class="col-12 text-center" v-if="zonas">
                <template v-if="place.svg_teatros">
                    <SvgComponent 
                        :zonas="zonas_formated" 
                        :place="place" 
                        :sesion_id="sesion_id"
                        @clickZona="irAZona"
                    ></SvgComponent>
                </template>
                <template v-else>
                    <RecintoComponent :place="place" :zonas="zonas_formated" :zona_id="zona.id" :can_click="true" :popup_enabled="true" :occupied="true" @clickZona="irAZona"></RecintoComponent>
                </template> 
                
            </div>
        </div>
    </div>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import RecintoComponent from '@/components/svg/RecintoComponent';        
    import SvgComponent from '@/components/svg/SvgComponent';

    export default {
        props: ['zona', 'zonas', 'dia_abonado', 'place', 'sesion_id'],
        data() {
            return {
                loading: true,
                new_zona: null,
                title: true
            }
        },
        computed: {
            select_zonas() {
                var select = [];
                for (var i = 0; i < this.zonas.length; i++) {
                    if(this.zonas[i].esta_disponible) {
                        select.push(this.zonas[i]);
                    }
                }

                return select;
            },
            zonas_formated() {
                var array = [];

                if(!this.dia_abonado) {
                    return this.zonas;
                } else {
                   for(var zona in this.zonas) {
                        array.push(this.zonas[zona]);
                        var precios_array = [];

                        for(var pa in array[zona].precios_abonados) {
                            precios_array.push({
                                'descripcion': array[zona].precios_abonados[pa].description,
                                'gd': array[zona].precios_abonados[pa].price_management_taquilla,
                                'gd_interno': array[zona].precios_abonados[pa].price_management_taquilla_interno,
                                'id': array[zona].precios_abonados[pa].id,
                                'precio': array[zona].precios_abonados[pa].price,
                                'precio_total': array[zona].precios_abonados[pa].price + array[zona].precios_abonados[pa].price_management_taquilla
                            })
                        }

                        array[zona].precios = precios_array;
                        var disponible = precios_array.length > 0 && array[zona].esta_disponible ? true : false;
                        array[zona].esta_disponible = disponible;
                    }

                    return array; 
                }                
            }
        },
        watch: {
            new_zona() {
                if(this.new_zona != null) {
                    this.$emit('changeZona', this.new_zona);
                    this.new_zona = null;
                }
            },
            loading() {
                this.title = false;
                this.title = true;
            }
        },
        methods: {
            irAZona(zona) {
                this.$emit('changeZona', zona);
            }
        },
        components: {
            TitleComponent, RecintoComponent, SvgComponent
        }
    }
</script>
